const moduleKey = "machineOverviewWidget";

export const machineOverviewWidgetEn = {
  [moduleKey]: {
    lastUpdated: "Last status update",
    metrics: {
      kind: {
        remaining_time: "Remaining Time",
        quality: "Quality",
      },
    },
  },
};

export const machineOverviewWidgetPtBr = {
  [moduleKey]: {
    lastUpdated: "Ultima atualizacao de status",
    metrics: {
      kind: {
        remaining_time: "Tempo Restante",
        quality: "Qualidade",
      },
    },
  },
};

export const machineOverviewWidgetDe = {
  [moduleKey]: {
    lastUpdated: "Letzte Statusaktualisierung",
    metrics: {
      kind: {
        remaining_time: "Verbleibende Zeit",
        quality: "Qualität",
      },
    },
  },
};

export const machineOverviewWidgetZhHans = {
  [moduleKey]: {
    lastUpdated: "最后状态更新",
    metrics: {
      kind: {
        remaining_time: "剩余时间",
        quality: "合格率",
      },
    },
  },
};

export const machineOverviewWidgetEs = {
  [moduleKey]: {
    lastUpdated: "Ultima actualizacion de estado",
    metrics: {
      kind: {
        remaining_time: "Tiempo Restante",
        quality: "Calidad",
      },
    },
  },
};

export const machineOverviewWidgetIt = {
  [moduleKey]: {
    lastUpdated: "Ultimo aggiornamento stato",
    metrics: {
      kind: {
        remaining_time: "Tempo Rimanente",
        quality: "Qualità",
      },
    },
  },
};

export const machineOverviewWidgetNl = {
  [moduleKey]: {
    lastUpdated: "Laatste statusupdate",
    metrics: {
      kind: {
        remaining_time: "Resterende tijd",
        quality: "Kwaliteit",
      },
    },
  },
};

export const machineOverviewWidgetTr = {
  [moduleKey]: {
    lastUpdated: "Son durum güncellemesi",
    metrics: {
      kind: {
        remaining_time: "Kalan Süre",
        quality: "Kalite",
      },
    },
  },
};
